var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerticallyAlign = function SvgVerticallyAlign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 22v-1.25h2.5V22zm0-6.25V14.5h2.5v1.25zm0-6.25V8.25h2.5V9.5zm0-6.25V2h2.5v1.25zm7.5 16.25H5.75V17h12.5zM22 13.25H2v-2.5h20zM18.25 7H5.75V4.5h12.5z"
  })));
};
export default SvgVerticallyAlign;